<app-form-custmenubase
    [dataItem]="dataItem"
    [screenList]="screenList"
    (onValidate)="validate($event)"
    (onCancel)="cancel($event)"
    (onDelete)="delete($event)"
>
</app-form-custmenubase>
